import { Box } from 'native-base';
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInWeeks,
} from 'date-fns';

// Icons
import { FireIcon, ClockIcon } from 'react-native-heroicons/solid';

// Assets
import { theme } from '@breakroom-nx/assets';
import { timeFrom } from '@breakroom-nx/helpers';

const LOW_MINUTES = 15;

export class Streak {
  timestamp: Date;

  constructor(timestamp: Date) {
    this.timestamp = timestamp;
  }

  // Functions
  getDuration(): string {
    return timeFrom(this.timestamp);
  }
  getMinutesLeft() {
    return differenceInMinutes(this.timestamp, new Date());
  }

  getColor() {
    return this.isExpiring()
      ? theme.colors.red[200]
      : theme.colors.primary[400];
  }

  isExpiring() {
    return this.getMinutesLeft() < LOW_MINUTES;
  }

  getIcon(color?: string, size?: number) {
    const fireIcon = (
      <FireIcon
        color={color ? color : this.getColor()}
        size={size ? size : 13}
      />
    );
    const clockIcon = (
      <ClockIcon
        color={color ? color : this.getColor()}
        size={size ? size : 13}
      />
    );

    return (
      <Box
        style={{
          shadowColor: 'black',
          shadowRadius: 5,
          shadowOffset: { width: 0, height: 3 },
          shadowOpacity: 0.3,
        }}
      >
        {this.isExpiring() ? clockIcon : fireIcon}
      </Box>
    );
  }
}
